const CURRENCY = `/functions/c_currency.php`
const CART = `/functions/cart_service.php`
const PRODUCTINFO = `/functions/get_info.php`
const PRODUCTREVIEW = `/functions/product_review.php`
const SEARCH = `/functions/header_search.php`
const CHECKSIZE = `/functions/request_size.php`
const PRODUCTSIZE = `/functions/check_availability.php`
const CAROUSEL = `/functions/carousel_async.php`
const PRODUCTLIST = `/functions/listing_filter.php`
const REVIEWS = `/functions/update_reviews.php`
const COMPAREPRICE = `/functions/price_comparison.php`
const WISHLIST = `/functions/add-to-wishlist.php`
const NEWSLETTER = `/functions/newsletter_subscription.php`
const CF = `/functions/calcolo_cf.php`

module.exports = { CURRENCY, CART, PRODUCTINFO, SEARCH, PRODUCTSIZE, CHECKSIZE, PRODUCTREVIEW, CAROUSEL, PRODUCTLIST, REVIEWS, COMPAREPRICE, WISHLIST, NEWSLETTER, CF }